module.exports = __webpack_public_path__ + "static/media/2_build.62e1260f.png";